// There doesn't seem to be a polyfill available for `Element.checkVisibility()` yet. This is a band-aid.

if (!Element.prototype.checkVisibility) {
  Element.prototype.checkVisibility = function () {
    return (
      this.style.display !== 'none' &&
      this.parentElement &&
      this.parentElement.style.display !== 'none' &&
      this.style.opacity !== 0 &&
      this.style.visibility !== 'hidden' &&
      this.style.contentVisibility !== 'hidden'
    );
  };
}
